import script from "./CartGroupItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartGroupItem.vue?vue&type=script&setup=true&lang=ts"

import "./CartGroupItem.vue?vue&type=style&index=0&id=199184de&lang=css"

const __exports__ = script;

export default __exports__